import React from "react";
import Title from "../layouts/Title";
import {
  projectOne,
  projectTwo,
  projectThree,
  projectFour,
  projectFive,
  projectSix,
  projectSeven,
  projectEight,
  projectNine,
  projectTen,
  projectEleven,
  projectTwelve,
  projectThirteen,
  projectFourteen,
  projectFifteen,
  projectSixteen,
  projectSeventeen,
  projectEighteen,
  projectNineteen,
  projectTwenty,
  projectTwentyOne,
  projectTwentyTwo,
  projectTwentyThree,
  projectTwentyFour,
  projectTwentyFive,
  projectTwentySix,
  projectTwentySeven,
  projectTwentyEight,
  projectTwentyNine,
  projectThirty,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";
import { FaGlobe } from "react-icons/fa";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14"
        data-aos="zoom-out-up"
      >
        <ProjectsCard
          title="E-Commerce Website-Noakzy"
          des=" Noakzy.com is the people’s retailer outlet. Our online store is truly a place for discovering the best home appliances"
          src={projectOne}
          site={
            <a href="https://www.noakzy.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="E-commerce Website-Jamarah Home"
          des=" The online store for home appliance!"
          src={projectTwo}
          site={
            <a href="https://www.jamarahome.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Real Estate-ercilemproperties"
          des=" Ercilem property and home’s services limited offered various services. Property Cities  Ibeju Lekki, Epe Town, Eti Osa"
          src={projectThree}
          site={
            <a href="https://ercilemproperties.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Simple Company Website "
          des=" A Simple Company website built with react js"
          src={projectFour}
          site={
            <a
              href="https://simple-company-website2.netlify.app/"
              target="_blank"
            >
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title=" Legal Leeds"
          des=" Legal Services."
          src={projectFive}
          site={
            <a href="https://leedslegalng.com" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="E-Commerce"
          des="Paypoints Investing Limited is a reputable limited liability company incorporated in 2009"
          src={projectSix}
          site={
            <a href="https://paypointsltd.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="E-Commerce"
          des="GoldBand-Ecoomerce"
          src={projectSeven}
          site={
            <a href="https://goldbandtechltd.com//" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Mordytech-Ecommerce"
          des=" The online store.!"
          src={projectEight}
          site={
            <a href="http://mordytech.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="School Management System"
          des=" School Tech is an advanced platform designed for schools to effectively manage their academic records, financial accounts, and administrative activities. It is powered by Dammietech Solutions, a seasoned web development agency with more than 7 years of expertise in delivering ICT solutions to schools and various organizations."
          src={projectNine}
          site={
            <a href="https://schooltech.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Food Restaurant Menu"
          des="Restaurant-Food Menu (reactjs)"
          src={projectTen}
          site={
            <a href="https://restoran-food-menu.netlify.app/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="E-Commerce-adebowaleemporium"
          des=" The Online Store!"
          src={projectEleven}
          site={
            <a href="https://adebowaleemporium.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="cjd musical instrument"
          des=" E-commerce for Musical Instrument"
          src={projectTwelve}
          site={
            <a href="https://cjdmusicalinstruments.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Color Flipper"
          des=" Color Flipper is a fun mini javascript project where you create a simple button, that on click, runs a function that generates a random color! (Javascript)"
          src={projectThirteen}
          site={
            <a href="https://jesse-color-flipper.netlify.app/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="YOUTH EMPOWERMENT PROGRAM"
          des=" This is A Special Online Program For Those With No Website Design Skill

 "
          src={projectFourteen}
          site={
            <a href="https://demo.noakzy.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Educational Brands"
          des="The African Brands Academy is a Leading Capacity Building Institution for Branding"
          src={projectFifteen}
          site={
            <a href="https://theafricanbrandsacademy.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Law Firm"
          des="AGABI, SHINABA, OGON & CO is a multi-dimensional Law Firm"
          src={projectSixteen}
          site={
            <a href="https://agashog.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Portfolio Website"
          des="Portfolio Website built with react (React)"
          src={projectSeventeen}
          site={
            <a href="https://portfolios-job.netlify.app/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Hotel and Hospitality"
          des="First Hotel for business and leisure travelers (reactjs)"
          src={projectEighteen}
          site={
            <a
              href="https://hostel-and-hospitality.netlify.app/"
              target="_blank"
            >
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Hotelier"
          des="Discover a Brand Luxury Hotel (reactjs)"
          src={projectNineteen}
          site={
            <a href="https://relax-home.netlify.app/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Demaskonnect"
          des="Sport Marketing and Agency"
          src={projectTwenty}
          site={
            <a href="https://demaskonnect.com" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Tabeeb general"
          des="Retail Lending"
          src={projectTwentyOne}
          site={
            <a href="https://tabeebgeneral.com" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Ronik International School"
          des="Ronik International School is committed to providing total quality training and service, focusing on mental and moral development."
          src={projectTwentyTwo}
          site={
            <a href="https://ronikinternationalschools.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Sure Golfing"
          des="Golfing Institute"
          src={projectTwentyThree}
          site={
            <a href="https://suregolfing.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Stan Oak"
          des="OAK Limited: An indigenous Oil and Gas Servicing Company"
          src={projectTwentyFour}
          site={
            <a href="https://stan-oak.co.uk" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="brixvia harmony solutions"
          des="A cleaning service compnay specializes in providing professional Cleaning solutions,
for residential,commercial, and industries spaces"
          src={projectTwentyFive}
          site={
            <a href="https://brixviaharmonysolutions.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="metromellow- Best Home Services"
          des="Trusted professionals for house cleaning, laundry service, fresh meal delivery, and pest control Same-day service available."
          src={projectTwentySix}
          site={
            <a href="https://metromellow.com" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="The Official Website of Ikeja2 Horeb Cathedral"
          des="Welcome to the official website of Horeb Cathedral Ikeja 2. Here, you can find information about upcoming events, news, , and inspiring videos"
          src={projectTwentySeven}
          site={
            <a href="https://ccchorebcathedralikeja2.org.ng" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Paylitu"
          des="PAYLITU Allows you to make flexible purchase at your comfort and connects you to various products like  furniture, Solar and Lithium Battery Inverter, electronics and more."
          src={projectTwentyEight}
          site={
            <a href="https://paylitu.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Bloomridesharerentalcarz"
          des="Bloom RideShare Rental Carz was created with one goal in mind — to help rideshare drivers in Bloom RideShare Rental Carz earn more with reliable, affordable vehicles built specifically for Uber, Lyft, and airport trips.."
          src={projectTwentyNine}
          site={
            <a href="https://bloomridesharerentalcarz.com/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
        <ProjectsCard
          title="Pioneer Surplus"
          des="We offer a wide range of laptops, desktops, and accessories from top brands like Dell, Lenovo, HP, and Apple – all with great prices, fast delivery, and awesome customer support. Whether you’re a student, professional, or gamer, we’ve got the perfect tech for you!."
          src={projectThirty}
          site={
            <a href="https://pioneersurplus.com.ng/" target="_blank">
              <FaGlobe />
            </a>
          }
        />
      </div>
    </section>
  );
};

export default Projects;
